import * as httpClient from "../util/httpClient";
import { MonitorType } from "../util/common";
import { IAddress } from "./csid/types";
export const getMonitors = () => {
    // As we are getting all monitors, we are not passing request object
    const request = {
        type: [MonitorType.All],
    };
    return httpClient.sendRequest("POST", `api/monitor/monitor`, request);
};

export const createSessionToken = () => {
    return httpClient.sendRequest("GET", `web/sessiontoken/CreateSessionToken`);
};

export const getPartnerConfig = (RetailerCode?: string, LookupType?: string, LookupValue?: string) => {
    const requestBody = { RetailerCode, LookupType, LookupValue };
    return httpClient.sendRequest("POST", `web/partner/get-partner-config`, requestBody);
};

export const getCatalogProducts = () => {
    return httpClient.sendRequest("GET", `api/partner-configuration/get-catalog-products`);
};

export const getPartnerLanguageOptions = () => {
    return httpClient.sendRequest("GET", `api/partner-configuration/get-partner-language`);
};

export const saveUserLanguagePreference = (languageId: number) => {
    return httpClient.sendRequest("PUT", `api/userServices/language/${languageId}`);
};

export const getFraudAlertReminder = () => {
    return httpClient.sendRequest("POST", `api/fraudAlertReminder/getFraudAlertReminder`);
};

export const getUserService = () => {
    return httpClient.sendRequest("GET", `api/userServices/GetUserService`);
};

export const postLegacyWrittenInstructionTimestamp = () => {
    return httpClient.sendRequest("POST", `api/userServices/AddIDFLegacyWrittenInstructionTimestamp`);
};

export const isTuCanadaProvider = (packageCode: string) => {
    const requestBody = { packageCode: packageCode };
    return httpClient.sendRequest("POST", `api/partnerservice/isTuCanadaProvider`, requestBody);
};

export const GetProtectionSuiteDownloadCount = () => {
    return httpClient.sendRequest("POST", `/api/PCProtectionTool/GetProtectionSuiteDownloadCount`);
};

export const getPaymentReceiptDetail = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/paymentInfo/getPaymentReceiptDetails`, requestBody);
};

export const getUserNextSteps = () => {
    return httpClient.sendRequest("GET", `api/nextSteps/getUserNextSteps`);
};

export const updateUserStepItem = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/nextSteps/updateUserStepItem`, requestBody);
};
export const getTUOtpGenerationKey = () => {
    var response = httpClient.sendRequest("POST", `web/configuration/get-tu-otp-code-generation-key`);
    return response;
};

export const getIDFLoginURL = () => {
    return httpClient.sendRequest("POST", `web/configuration/get-idf-redirect-login-url`);
};

export const getIDFUserDetails = (requestBody: { email: string }) => {
    return httpClient.sendRequest("POST", `api/authentication/get-idf-user-details`, requestBody);
};

export const getUserLetsgetStartedFlows = () => {
    return httpClient.sendRequest("GET", `api/nextSteps/GetUserLetsgetStartedFlows`);
};

export const dismissAllItemsByFlowType = (flowType: string) => {
    return httpClient.sendRequest("GET", `api/nextSteps/DismissAllItemsByFlowType?flowType=${flowType}`);
};

export const addFamilyPlanMember = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/family/add-family-plan-member`, requestBody);
};

export const addFamilyMember = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/family/add-paid-family-member`, requestBody);
};

export const addUserPaidFamilyPlanMember = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/family/add-user-paid-family-plan-members`, requestBody);
};

export const getPayAsYouGoPackageDetails = () => {
    return httpClient.sendRequest("POST", `web/user/get-payasyougo-package-details`);
};

export const renewPayAsYouGoFamilyMember = (requestBody: any) => {
    return httpClient.sendRequest("POST", "web/user/renew-user-paid-family-plan-members", requestBody);
};

export const cancelPayAsYouGoFamilyMembers = (requestBody: any) => {
    return httpClient.sendRequest("POST", `web/user/cancel-payasyougo-family-members`, requestBody);
};

export const getPayementProfileValidity = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/family/is-valid-user-paid-members-billing-profile`, requestBody);
};

export const checkCompleteAccountSetup = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/family/check-complete-account-setup`, requestBody);
};

export const completeAccountSetup = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/family/complete-account-setup`, requestBody);
};

export const completeAccountSetupEZS = (requestBody: any) => {
    return httpClient.sendRequest("POST", `web/user/complete-account-setup`, requestBody);
};

export const removeIDFFamilyAccount = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/family/remove-family-member`, requestBody);
};

export const removeUserPaidFamilyMember = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/family/remove-user-paid-family-members`, requestBody);
};

export const getPayAsYouGoAmountDetails = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/family/get-payasyougo-amount-details`, requestBody);
};

export const getUserAddPrice = () => {
    return httpClient.sendRequest("POST", `api/family/get-user-family-add-price`);
};

export const postTransactionMonitor = () => {
    return httpClient.sendRequest("POST", `api/financial-account/monitors`, {});
};

export const getTransactionMonths = () => {
    return httpClient.sendRequest("GET", `api/financial-account/transaction-months`);
};
//================================== User Services =========================================

export const getAllTUServiceWithLabel = () => {
    return httpClient.sendRequest("GET", `api/userServices/GetAllTUServiceWithLabel`);
};

export const getPackagesUpgradeDowngrade = () => {
    return httpClient.sendRequest("GET", `api/userServices/get-packages-upgrade-downgrade`);
};

export const getPackageUpdateForSSO = () => {
    return httpClient.sendRequest("GET", `api/userServices/CheckIfPackageUpdatedForSSOUser`);
};

export const getProtectionPlan = (isPayAsYouGo?: boolean) => {
    if (isPayAsYouGo) {
        return httpClient.sendRequest("GET", `api/userServices/get-packages-upgrade-downgrade-for-family`);
    }
    return httpClient.sendRequest("GET", `api/userServices/get-packages-upgrade-downgrade`);
};

export const getActiveOfferDetails = () => {
    return httpClient.sendRequest("GET", `api/userServices/Get-User-Active-Package-Enrollment`);
};

export const getAvalaraService = () => {
    return httpClient.sendRequest("GET", `web/user/get-avalara-packages-upgrade-downgrade`);
};
export const getIDFProtectionPlan = () => {
    return httpClient.sendRequest("GET", "api/userServices/GetIDFPackageMatrix");
};

export const getUpgradePackageAmountDetails = (requestBody: any) => {
    return httpClient.sendRequest("POST", `web/user/get-upgrade-package-amountdetails`, requestBody);
};

export const SmbUpgradeDowngradePackage = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/SmallBusinessCreditReport/UpgradeDowngradePackagesBusiness`, requestBody);
};

export const UpgradeDowngradePackage = (requestBody: any) => {
    return httpClient.sendRequest("POST", `web/user/upgrade-downgrade-packages`, requestBody);
};

export const UpgradeIDFPackage = (packageId: string) => {
    let requestBody = {
        "upgrading-members": [
            {
                "offer-id": packageId,
            },
        ],
        "use-current-billing-profile": true,
    };

    return httpClient.sendRequest("POST", "api/userservices/UpgradePackagesForIDF", requestBody);
};

export const PurchaseCreditReport = (productCode: string) => {
    let requestBody = {
        productCode: productCode,
    };
    return httpClient.sendRequest("POST", "api/userservices/PurchaseCreditReport", requestBody);
};

export const GetIDFPackageCancellationStatus = () => {
    return httpClient.sendRequest("GET", "api/userservices/GetCancellationStatus");
};

export const CancelIDFPackage = () => {
    return httpClient.sendRequest("DELETE", "api/userServices/CancelIDFPackage");
};

export const GetUserServiceInsuranceTerms = (serviceKey: string) => {
    var requestBody = {
        serviceKey: serviceKey,
    };
    const commonHeaders: any = {
        "Content-Type": "application/json",
        pragma: "no-cache",
        "cache-control": "no-cache",
        Accept: "application/json",
    };
    return httpClient.sendRequest("POST", `api/userServices/GetUserServiceInsuranceTerms`, requestBody, commonHeaders);
};
//================================== Billing Info =========================================

export const SaveBillingInfo = (requestBody: any) => {
    return httpClient.sendRequest("POST", `web/billing-info/save-billing-info`, requestBody).then((data) => {
        if (data.isSuccess) {
            PostCallOnBillingInfoChanged();
        }
        return data;
    });
};

export const saveBillingInfo = (requestBody: any) => {
    return httpClient.sendRequest("POST", `web/billing-info/save-billing-info`, requestBody);
};

export const saveBillingInfoUpdateTax = (requestBody: any) => {
    return httpClient.sendRequest("POST", `web/billing-info/save-billing-info-for-update-sales-tax`, requestBody);
};

export const SaveIDFPaymentInfo = (
    nameOnCard: string,
    cardNumber: string,
    cardType: string,
    expMonth: string,
    expYear: string,
    billingZip: string,
    securityCode: string,
    expirationDate?: string,
    billingAddress?: object
) => {
    const requestBody = {
        creditCardDetails: {
            cardType: {
                options: [cardType],
                readOnly: true,
            },
            nameOnCard: nameOnCard?.trimStart(),
            cardNumber: cardNumber,
            expDateMo: expMonth,
            expDateYr: expYear,
            securityCode: securityCode,
            expirationDate: expirationDate,
            billingZip: billingZip,
        },
        BillingAddress: billingAddress
    };
    return httpClient.post("web/billing-info/save-billing-info", requestBody);
};

export const GetAccountInformation = () => {
    return httpClient.sendRequest("GET", `api/accountInfo/getAccountInformation`);
};
export const GetPaymentDetail = () => {
    return httpClient.sendRequest("POST", `api/paymentInfo/getPaymentMethodDetails`, {});
};

export const GetContractChangeDetails = () => {
    return httpClient.sendRequest("GET", `api/userServices/GetContractChangeDetails`);
};

export const resendVerificationCode = () => {
    return httpClient.sendRequest("POST", `web/forgot-password/resend-verification-code`);
};

export const PostContractChangeReviewed = () => {
    var requestBody = {
        eventKind: "CGW_CONTRACT_CHANGE_REVIEWED",
        clientApplication: "Sontiq",
    };
    return httpClient.sendRequest("POST", `api/subscriberGateway/PrescribeSMGEvent`, requestBody);
};

export const checkSMGEvent = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/subscriberGateway/GetSubrSMGEventDetails`, requestBody);
};

export const PostContractChangeSucceed = () => {
    var requestBody = {
        eventKind: "CGW_CANCELLATION_CONTINUATION_SUCCEEDED",
        clientApplication: "Sontiq",
    };
    return httpClient.sendRequest("POST", `api/subscriberGateway/PrescribeSMGEvent`, requestBody);
};

export const PostCallOnBillingInfoChanged = () => {
    var requestBody = {
        eventKind: "CGW_PAYMENT_INFO_CHANGED",
        clientApplication: "Sontiq",
    };
    return httpClient.sendRequest("POST", `api/subscriberGateway/PrescribeSMGEvent`, requestBody);
};

export const GetCancellationContinuationView = (globalOfferCode: string) => {
    var requestBody = {
        globalOfferCode: globalOfferCode,
    };
    return httpClient.sendRequest("POST", `web/user/GetCancellationContinuationView`, requestBody);
};
//================================== Terms and Conditions =========================================

export const GetTermsAndConditions = (requestBody: any) => {
    return httpClient.sendRequest("POST", "api/termsandcondition/getTermsAndConditions", requestBody);
};

export const GetTermsAndConditionsInProtectionPlan = (requestBody: any) => {
    return httpClient.sendRequest("POST", "web/termsandcondition/get-terms-and-conditions-upgrade-downgrade", requestBody);
};
//================================== Web/User Service =========================================
export const getProductFeaturesOfBidr = () => {
    return httpClient.sendRequest("GET", `api/SmallBusinessResource/GetProductFeaturesOFBIDR`);
};

export const getUserFamily = () => {
    return httpClient.sendRequest("POST", `web/user/get-user-family`);
};

export const switchFamilyAccount = (requestBody: any) => {
    return httpClient.sendRequest("POST", `web/user/switch-family-account`, requestBody);
};

export const updateFamilyAccountEmail = (requestBody: any) => {
    return httpClient.sendRequest("POST", `web/user/update-email`, requestBody);
};

export const resendActivationEmail = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/family/resend-activation-email`, requestBody);
};
export const isIdfUser = () => {
    return httpClient.sendRequest("GET", `web/user/is-idf-user`);
};

export const isTuUser = () => {
    return httpClient.sendRequest("POST", `api/userServices/IdentifyTuUser`);
};

export const IsAutoEnrolledUser = () => {
    return httpClient.sendRequest("POST", `api/userServices/IdentifyAutoEnrolledUser`);
};

export const getCancelledUserFamily = (requestBody: any) => {
    return httpClient.sendRequest("POST", `web/user/get-cancelled-user-family`, requestBody);
};

//================================== Web/Partner Service =========================================
export const getEFTInfo = () => {
    return httpClient.sendRequest("POST", `web/partner/get-eft`, {});
};

// ================================== CSID ============================================
export const orderOneTimeCreditReport = (reportServiceName: string) => {
    const requestBody = {
        "report-service-name": reportServiceName,
    };
    return httpClient.post("api/credit-monitoring/orderCreditReportOneTime", requestBody);
};

export const getUserCSIDStatus = () => {
    return httpClient.post("api/credit-monitoring/validateAuthentication");
};

export const GetParentL3Status = () => {
    return httpClient.get("web/user/get-parent-l3-status");
};

export const isExperialL3Required = () => {
    return httpClient.sendRequest("GET", `api/credit-monitoring/getExperianL3RequiredStatus`);
};

export const isTuCanadianUser = () => {
    return httpClient.sendRequest("GET", `api/credit-monitoring/isTuCanadianUserStatus`);
};

export const enrollUserinCSID = (SSN: string, DOB: string) => {
    const requestBody = {
        ssn: SSN,
        dob: DOB,
    };
    return httpClient.post("api/credit-monitoring/EnrollUserInCSID", requestBody);
};

export const updateUserinCSID = (SSN: string, DOB: string) => {
    const requestBody = {
        ssn: SSN,
        dob: DOB,
    };
    return httpClient.post("api/credit-monitoring/UpdateUserInCSID", requestBody);
};

export const saveSsnAndDob = (ssn?: string, dob?: string) => {
    const requestBody = {
        ssn: ssn,
        dob: dob,
    };
    return httpClient.post("api/userInfo/SaveSsnAndDob", requestBody);
};

export const enrollCCAM = (requestBody: any) => {
    return httpClient.sendRequest("POST", "web/user/ManageChildMonitoringAsync", requestBody);
};

export const sendEmailNotification = (requestBody: any) => {
    return httpClient.sendRequest("POST", "api/emailnotification/sendEmail", requestBody);
};

// ================================== L3 ============================================
export const getL3SecurityQuestion = (
    SSN: string,
    postponeActivation: boolean,
    DOB?: string,
    address?: IAddress,
    phoneNumber?: string,
    tuTrustedSessionId?: string,
    language?: string
) => {
    if (phoneNumber && phoneNumber.length > 10) {
        phoneNumber = phoneNumber.substring(phoneNumber.length - 10);
    }
    const requestBody = {
        ssn: SSN,
        dob: DOB,
        address: address,
        phoneNumber: phoneNumber,
        "postpone-activation": postponeActivation,
        Language: language,
        tuTrustedSessionId: tuTrustedSessionId,
    };

    return httpClient.post("web/user/getAuthQuestion", requestBody);
};
//blackbox api
export const getBlackBoxSessionID =(blackBox?:string, clientIP?:string, sessionType?:string)=>{
    const requestBody ={
        BlackBox : blackBox,
        Details : [ { clientIp :clientIP } ],
        SessionType: sessionType,
    };
    return httpClient.post("api/credit-monitoring/GetTUSessionIDForMobile", requestBody);
}
export const sendNewTUOTPCode = (
    selectedOptionText: string,
    SSN: string,
    postponeActivation: boolean,
    DOB?: string,
    address?: IAddress,
    phoneNumber?: string,
    tuTrustedSessionId?: string
) => {
    if (phoneNumber && phoneNumber.length > 10) {
        phoneNumber = phoneNumber.substring(phoneNumber.length - 10);
    }
    const requestBody = {
        ssn: SSN,
        dob: DOB,
        address: address,
        phoneNumber: phoneNumber,
        selectedOTPOptionText: selectedOptionText,
        "postpone-activation": postponeActivation,
        tuTrustedSessionId: tuTrustedSessionId,
    };

    return httpClient.post("api/credit-monitoring/sendNewTUOTPCode", requestBody);
};

export const submitL3SecurityQuestionAnswer = (
    answers: any,
    postponeActivation: boolean,
    ssn?: string,
    dob?: string,
    address?: IAddress,
    tuTrustedSessionId?: string
) => {
    const requestBody = {
        "authentication-question-answer": {
            "postpone-activation": postponeActivation,
            answers: answers,
        },
        ssn: ssn,
        dob: dob,
        address: address,
        tuTrustedSessionId: tuTrustedSessionId,
    };
    return httpClient.put("web/user/submitAuthQuestionAnswer", requestBody);
};

export const verifyOTPAuthentication = (answers: any, postponeActivation: boolean, ssn?: string, dob?: string, address?: IAddress, tuTrustedSessionId?: string) => {
    const requestBody = {
        "authentication-question-answer": {
            "postpone-activation": postponeActivation,
            answers: answers,
        },
        ssn: ssn,
        dob: dob,
        address: address,
        tuTrustedSessionId: tuTrustedSessionId,
    };

    return httpClient.put("web/user/verifyOTPAuthentication", requestBody);
};

export const updateL3AttemptReason = (reasonCode?: string, reasonText?: string) => {
    if (reasonCode == null || reasonCode.trim().length === 0) {
        reasonCode = "TIMEOUT";
    }
    if (reasonText == null || reasonText.trim().length === 0) {
        reasonText = "L3 Timer timed out";
    }
    const requestBody = {
        ReasonCode: reasonCode,
        ReasonText: reasonText,
    };
    return httpClient.put("api/credit-monitoring/updateL3AttemptReason", requestBody);
};
export const updateL3Status = (status?: string) => {
    
    if (status == null || status.trim().length === 0) {
        status = "l3-timeout-locked";
   }
    const requestBody = {
      Status: status
    };
    return httpClient.put("api/credit-monitoring/updateL3Status", requestBody);
};
// TODO: invoke the api to save the L3 disclosure agree by user
export const submitL3UserDisclosureAgreement = () => {};

//================================== FPS Get Child Subscribers =========================================
export const getChildSubscribersFPS = () => {
    return httpClient.sendRequest("GET", `api/family/get-child-subscribers-fps`);
};

//================================== FPS Get Child Subscribers =========================================
export const addFamilyMembersFPS = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/family/add-family-member-fps`, requestBody);
};

//================================== Add Seniors Fraud Resolution =========================================
export const addSeniorFamilyMember = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/family/AddSeniorFamilyMember`, requestBody);
};

//================================== Update Seniors Fraud Resolution =========================================
export const updateSeniorFamilyMember = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/familyService/EditSeniorFamilyMember`, requestBody);
};

//================================== Get Senior Family Member List =========================================
export const getSeniorFamilyMember = () => {
    return httpClient.sendRequest("GET", `api/familyService/GetSeniorFamilyMember`);
};

//================================== Delete Senior Family Member =========================================
export const deleteSeniorFamilyMember = (id: number) => {
    return httpClient.sendRequest("POST", `api/familyService/DeleteSeniorFamilyMember?Id=${id}`);
};

//==================================== SecureVault =========================================================
export const getLostWalletData = () => {
    const requestBody = {
        "lost-wallet-key": "Test@123",
    };

    return httpClient.sendRequest("POST", `api/lostWallet/getWalletItemList`, requestBody);
};

//====================================Dark Web =========================================================
export const addDardWebMonitoringCreditCard = (creditCardNumber: string) => {
    const requestBody = {
        asset: {
            creditCardInformation: {
                "monitor-creditcard": {
                    "credit-card": creditCardNumber,
                    "is-monitored": true,
                    action: "ADD",
                },
            },
        },
    };
    return manageMonitoring(requestBody);
};

export const addDardWebMonitoringBankAccount = (accountNumber: string, routingNumber: string, accountType: string) => {
    let requestObj = {};
    if (accountType === "US") {
        requestObj = {
            asset: {
                bankAccountInformation: {
                    "monitor-bankaccount": {
                        "bank-account": accountNumber,
                        "routing-number": routingNumber,
                        "is-monitored": true,
                        action: "ADD",
                    },
                },
            },
        };
    } else {
        requestObj = {
            asset: {
                ibanAccountInformation: {
                    "monitor-ibanaccount": {
                        "bank-account": accountNumber,
                        "is-monitored": true,
                        action: "ADD",
                    },
                },
            },
        };
    }
    return manageMonitoring(requestObj);
};

export const getMonitoring = () => {
    const requestBody = {};
    return httpClient.sendRequest("post", `api/secureMonitoring/getMonitoringAssetList`, requestBody);
};

export const getMonitoringAfterUpdate = (payload: any) => {
    const requestBody = payload;
    return httpClient.sendRequest("post", `api/secureMonitoring/getMonitoringAssetList`, requestBody);
};

export const deleteMonitoring = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/secureMonitoring/deleteMonitoringInfo`, requestBody);
};

export const manageMonitoring = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/secureMonitoring/manageMonitoredAssets`, requestBody);
};

export const getPartnerLatestTermsConditions = () => {
    return httpClient.sendRequest("POST", `api/termsandcondition/getPartnerLatestTermsConditions`);
};

export const acceptTermsConditions = () => {
    return httpClient.sendRequest("POST", `api/termsandcondition/acceptTermsConditions`);
};

export const isUserAuthenticated = () => {
    return httpClient.sendRequest("GET", "web/login/GetUserLoginAuthStatus");
};

export const getCountryList = (IsIDFPartner:boolean,partnerID: number) => {
    var requestBody = {partnerID: partnerID ,isIDFPartner: IsIDFPartner};
    return httpClient.sendRequest("POST", "api/Country/GetCountryList",requestBody);
};

export const getAuthenticationType = ({ email }: any) => {
    return httpClient.sendRequest("POST", "api/authentication/get-authentication-type", { email });
};

//==================================RSS FEED=========================//
export const getRSSFeed = (feedType: string, catagory?: string, contentName?: string) => {
    return httpClient.get("web/rssfeed/GetRSSFeed?feedType=" + feedType + "&categoryName=" + catagory + "&contentName=" + contentName + "");
};

//==================================RSS FEED Details=========================//
export const getRSSFeedDetails = (id: string) => {
    const requestData = {
        feedId: id,
    };
    return httpClient.sendRequest("POST", "web/rssfeed/get-rss-feed-details", requestData);
};

//=========================Small Business Resource =====================================//
export const getQuestionaires = () => {
    return httpClient.sendRequest("GET", "api/SmallBusinessResource/GetQuestionaires");
};

export const submitAssessmentAnswers = (answers: any) => {
    let requestBody = { Answers: answers };
    return httpClient.sendRequest("POST", "api/SmallBusinessResource/SubmitAssessmentAnswers", requestBody);
};

export const getSecurityAssessmentReview = () => {
    return httpClient.sendRequest("GET", "api/SmallBusinessResource/GetSecurityAssessmentReview");
};

export const getWhiteHawkAssessmentSummary = () => {
    return httpClient.sendRequest("GET", "api/SmallBusinessResource/GetWhiteHawkAssessmentSummary");
};

export const getSecurityAssessmentQuestionaires = () => {
    return httpClient.sendRequest("GET", "api/SmallBusinessResource/GetSecurityAssessmentQuestionaires");
};

export const deleteSecurityAssessmentUserAnswers = () => {
    return httpClient.sendRequest("POST", "api/SmallBusinessResource/DeleteSecurityAssessmentUserAnswers");
};

export const submitSecurityAssessmentUserAnswers = (requestBody: any) => {
    return httpClient.sendRequest("POST", "api/SmallBusinessResource/SubmitSecurityAssessmentUserAnswers", requestBody);
};

//=========================Small Business Profile =====================================//
export const getSmbContactInfo = () => {
    return httpClient.sendRequest("POST", "api/userInfo/getContactInfo", {});
};

export const createBusinessCreditProfileCase = (requestBody: any) => {
    return httpClient.sendRequest("POST", "api/SmallBusinessCreditReport/CreateSalesForceBusinessProfileCase", requestBody);
};

export const SearchCompany = (requestBody: any) => {
    return httpClient.sendRequest("POST", "api/SmallBusinessCreditReport/SearchCompany", requestBody);
};
export const RegisterBusinessForCreditMonitoring = (requestBody: any) => {
    return httpClient.sendRequest("POST", "api/SmallBusinessCreditReport/RegisterBusinessForCreditMonitoring", requestBody);
};

//=========================Small Business Credit =====================================//
export const getBusinessCreditReport = (ReportPK: any, creditProvider: string) => {
    let requestBody = {};
    if (ReportPK == null) {
        requestBody = { CreditProvider: creditProvider };
    } else {
        requestBody = { CreditProvider: creditProvider, ReportPK: ReportPK };
    }

    return httpClient.sendRequest("POST", "api/SmallBusinessCreditReport/GetBusinessCreditReport", requestBody);
};

export const getNewBusinessCreditReport = (ReportPK: any, creditProvider: string) => {
    let requestBody = {};
    if (ReportPK == null) {
        requestBody = { CreditProvider: creditProvider };
    } else {
        requestBody = { ReportPK: ReportPK };
    }

    return httpClient.sendRequest("POST", "api/SmallBusinessCreditReport/OrderNewBusinessCreditReport", requestBody);
};

export const getAllBusinessCreditHistory = () => {
    return httpClient.sendRequest("GET", "api/SmallBusinessCreditReport/GetSMBCreditHistory");
};

export const getBusinessCreditTracker = (creditProvider: string) => {
    let requestBody = { MaxLimit: "6", CreditProvider: creditProvider };
    return httpClient.sendRequest("POST", "api/SmallBusinessCreditReport/GetBusinessCreditScoreTracker", requestBody);
};

export const getRedirectionUrl = (redirectToken?: string) => {
    return httpClient.sendRequest("POST", `api/userServices/GetRedirectPath?redirectToken=${redirectToken}`);
};

export const getSearchBreachByName = (requestBody: { name: string }) => {
    return httpClient.sendRequest("POST", `api/breachclarity/getPremiumSearchBreachesByName`, requestBody);
};
export const getBreachById = (requestBody: { id: string }) => {
    return httpClient.sendRequest("POST", `api/breachclarity/getPremiumBreachesById`, requestBody);
};

export const savePremiumBreachesByBreachId = (requestBody: { BreachIDs: any; Source: any }) => {
    return httpClient.sendRequest("POST", `api/breachclarity/savePremiumBreachesByBreachId`, requestBody);
};

export const removePremiumBreachesByBreachId = (requestBody: { BreachIDs: any; Source: any }) => {
    return httpClient.sendRequest("POST", `api/breachclarity/deletePremiumBreachesByBreachId`, requestBody);
};
export const getDetectedBreach = () => {
    return httpClient.sendRequest("GET", `api/breachclarity/getDetectedBreaches`);
};
export const getSavedBreach = () => {
    return httpClient.sendRequest("GET", `api/breachclarity/getSavedBreaches`);
};
export const archiveDetectedBreachesByBreachId = (requestBody: { breachId: string; breachStatus: string; alertItemRequest: any }) => {
    return httpClient.sendRequest("POST", `api/breachclarity/updateDetectedBreachStatus`, requestBody);
};
export const setActionStep = (requestBody: { actionFiQueueId: any; actionId: number; actionName: string; actionStepLabel: string }) => {
    return httpClient.sendRequest("POST", `web/BreachClarity/UpdateActionStepLabelAndDate`, requestBody);
};
export const getBreachActionList = () => {
    return httpClient.sendRequest("GET", `api/breachclarity/getfiActionToDoList`);
};
export const completeBreachAction = (requestBody: { fiActionQueueId: any; id: number; name: string }) => {
    return httpClient.sendRequest("POST", `api/breachclarity/createCompletedAction`, requestBody);
};
export const updateBreachAction = (requestBody: any) => {
    return httpClient.sendRequest("POST", `web/BreachClarity/UpdateActionsByActionsCategory`, requestBody);
};

export const getBreachSummary = () => {
    return httpClient.sendRequest("GET", `api/breachclarity/getBreachSummaryDetails`);
};

export const getBreachScoreFactors = () => {
    return httpClient.sendRequest("GET", `api/breachclarity/getScoreAndFactors`);
};

export const getServicesAndCatalog = () => {
    return httpClient.sendRequest("GET", `api/userServices/Get-User-Active-Service-And-Catalog-Status`);
};

export const getPurchaseCreditReport = (productCode: string) => {
    let requestBody = { productCode: productCode };
    return httpClient.sendRequest("POST", `api/userServices/PurchaseCreditReport`, requestBody);
};

export const dismissBreachAlertMessage = (requestBody: { alertId: number }) => {
    return httpClient.sendRequest("POST", `api/messageBanner/DismissAlertMessage`, requestBody);
};

export const dismissMxMigrAlertMessage = () => {
    const requestBody =        {
            "messageType": "mxMigr",
            "statusFlag": false
          }
    return httpClient.sendRequest("PUT", `api/messageBanner/dismissBannerMessageDisplayStatus`, requestBody);
};

export const mxMigrAlertMessageStatus = () => {
    const requestBody= {
        "messageType": "mxMigr"
      }
    return httpClient.sendRequest("POST", `api/messageBanner/bannerMessageDisplayStatus`, requestBody);
};

//========================= RepIQ =====================================//
export const getReputationFAQContents = () => {
    return httpClient.sendRequest("POST", "api/rep-iq/faq/get-faq-contents");
};

export const getAnalysisResult = (requestBody: any) => {
    return httpClient.sendRequest("POST", "api/rep-iq/rep-iq-analyzer/analyze-file", requestBody);
};

export const getPresetProfile = () => {
    return httpClient.sendRequest("POST", "api/rep-iq/profile/get-preset-profile");
};

export const getUserNetworkStatus = () => {
    return httpClient.sendRequest("POST", "api/rep-iq/social-media/get-user-network-status");
};
export const getSocialNetworkAccountStatus = (requestBody: { "Network-Type": string }) => {
    return httpClient.sendRequest("POST", "api/zeroFOX/getSocialNetworkAccountStatus", requestBody);
};

export const getSocialMediaAnalysisHistory = () => {
    return httpClient.sendRequest("POST", "api/rep-iq/social-media/get-social-media-analysis-history");
};

export const getShowGettingStarted = () => {
    return httpClient.sendRequest("POST", "api/rep-iq/getting-started/get-show-getting-started");
};

export const setShowGettingStarted = () => {
    return httpClient.sendRequest("POST", "api/rep-iq/getting-started/set-show-getting-started");
};

export const disconnectSocialMediaAccount = (socialMediaNetworkID: number) => {
    let requestBody = { networkID: socialMediaNetworkID };
    return httpClient.sendRequest("POST", "api/rep-iq/social-media/disconnect-social-media-account", requestBody);
};

export const getSocialMediaOauthURL = (socialMediaNetworkID: number, internalCallbackUrl: string) => {
    let requestBody = { socialMediaNetworkID: socialMediaNetworkID, internalCallbackUrl: internalCallbackUrl };
    return httpClient.sendRequest("POST", "api/rep-iq/social-media/get-social-media-oauth-url", requestBody);
};

export const confirmMonitoring = (guid: any) => {
    let requestBody = { guid: guid };
    return httpClient.sendRequest("POST", "api/rep-iq/social-media/confirm-monitoring", requestBody);
};

export const startAnalyzePersonalityInsightsData = (guid: any) => {
    let requestBody = { guid: guid };
    return httpClient.sendRequest("POST", "api/rep-iq/social-media/start-analyze-personality-insight-data", requestBody);
};

export const generatePasswordResetLink = (email: string, partnerID: number) => {
    let requestBody = { email: email, partnerID: partnerID };
    return httpClient.sendRequest("POST", "api/authentication/generate-password-reset-link", requestBody);
};

export const validateResetPasswordURI = (guid: string, host: string) => {
    let requestBody = { guid: guid, partnerHostAlias: host };
    return httpClient.sendRequest("POST", "web/forgot-password/validate-reset-password-uri", requestBody);
};

export const validateEmail = (email: string, partnerID: number) => {
    let requestBody = { email: email, partnerID: partnerID };
    return httpClient.sendRequest("POST", "web/forgot-password/validate-email", requestBody);
};

export const getPartnerMigrationStatus = (partnerID: number) => {
    let requestBody = { partnerID: partnerID };
    return httpClient.sendRequest("POST", "api/authentication/get-partner-migration-status", requestBody);
};

export const validateDomain = (requestBody: any) => {
    return httpClient.sendRequest("POST", "api/validator/IsDomainBlackListed", requestBody);
};

export const getAccountSummary = () => {
   return httpClient.sendRequest("GET", `api/financial-account/account-summary`)
};

//Employee service

export const getEmployeeList = (status: string) => {
    return httpClient.sendRequest("POST", "api/SmallBusinessEmployee/GetEmployeeDetails", { status });
};

export const saveEmployeeDetails = (reqData: any) => {
    return httpClient.sendRequest("POST", "api/SmallBusinessEmployee/SaveEmployeeDetails", reqData);
};

export const uploadEmployeeDetails = (reqData: any) => {
    return httpClient.sendRequest("POST", "api/SmallBusinessEmployee/UploadFile", reqData);
};

export const getFileUploadStatus = () => {
    return httpClient.sendRequest("POST", "api/SmallBusinessEmployee/FileUploadStatus");
};

export const updateEmployeeRange = (payload: any) => {
    return httpClient.sendRequest("POST", "api/userServices/UpdateNumberOfEmployees", payload);
};

// MAV service

export const getChildTopRisks = (reqData: any) => {
    return httpClient.sendRequest("POST", "api/MobileAttackView/ChildTopRisks", reqData);
};
export const getChildViewSummary = (reqData: any) => {
    return httpClient.sendRequest("POST", "api/MobileAttackView/ChildMobileAttackViewSummary", reqData);
};
export const getChildDailyScans = (reqData: any) => {
    return httpClient.sendRequest("POST", "api/MobileAttackView/ChildDailyScans", reqData);
};
export const getDeviceDetails = (reqData: any) => {
    return httpClient.sendRequest("POST", "api/MobileAttackView/GetDeviceDetails", reqData);
};
export const getChildList = (reqData: any) => {
    return httpClient.sendRequest("POST", "api/MobileAttackView/ChildList", reqData);
};
export const getChildScanReport = (reqData: any) => {
    return httpClient.sendRequest("POST", "api/MobileAttackView/ChildScanReport", reqData);
};

export const acceptSsoTermsConditions = () => {
    return httpClient.sendRequest("POST", `web/Registration/complete-registration-for-sso-user`);
};

// Credit Lock service

export const getCreditLockStatus = () => {
    return httpClient.sendRequest("POST", `api/credit-lock/GetLockStatus`);
};
export const updateCreditStatusLock = () => {
    return httpClient.sendRequest("POST", `api/credit-lock/lock`);
};
export const updateCreditStatusUnlock = () => {
    return httpClient.sendRequest("POST", `api/credit-lock/unlock`);
};
export const getChildEnrollmentStatus = () => {
    return httpClient.sendRequest("GET", "api/userServices/GetChildMonitoringStatusAsync");
};

//Two Step Cancellation

//Get Two Step Cancellation States
export const getTwoStepCancellationStates = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/partnerservice/GetTwoStepCancellationStates`, requestBody);
};

//Send Event for two step cancellation
export const TwoStepCancellationEvent = () => {
    var requestBody = {
        eventKind: "TWO_STEP_CANCELLATION",
        clientApplication: "Sontiq",
    };
    return httpClient.sendRequest("POST", `api/subscriberGateway/PrescribeSMGEvent`, requestBody);
};

//Send Event for general cancellation
export const GeneralCancellationEvent = () => {
    var requestBody = {
        eventKind: "GENERAL_CANCELLATION",
        clientApplication: "Sontiq",
    };
    return httpClient.sendRequest("POST", `api/subscriberGateway/PrescribeSMGEvent`, requestBody);
};

export const generatedPdfService = (requestBody: any) => {
    return httpClient.sendRequest("POST", `api/Utilities/generatepdf`, requestBody);
};
export const getFamilyAdultMemberDetails = () => {
    return httpClient.sendRequest("GET", `web/user/GetFamilyAdultMemberDetails`);
};
